var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.001,
    viewBox: "0 0 18 18.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5050-1442a9.01,9.01,0,0,1-9-9,9.01,9.01,0,0,1,9-9,9.011,9.011,0,0,1,9,9A9.011,9.011,0,0,1,5050-1442Zm-5.749-10a1.251,1.251,0,0,0-1.25,1.249,1.252,1.252,0,0,0,1.25,1.251h11.5a1.252,1.252,0,0,0,1.25-1.251,1.251,1.251,0,0,0-1.25-1.249Z",
    transform: "translate(-5041 1460.001)",
    fill: "#d2d5da",
    opacity: 0.996
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopIcon);
export default __webpack_public_path__ + "static/media/stop-icon.5af572afd1b02c37880c8684c058b055.svg";
export { ForwardRef as ReactComponent };